import { useCallback as a } from "react";
function m() {
  return a(
    ({
      targetElement: c = document.body,
      behavior: i = "auto",
      position: l = "start",
      scrollOffset: e = 0
    }) => {
      var r;
      if (!c) return;
      const t = c.getBoundingClientRect(), o = window.scrollY || document.documentElement.scrollTop, d = window.scrollX || document.documentElement.scrollLeft, s = ((r = document.querySelector("#top-nav")) == null ? void 0 : r.clientHeight) ?? 0, n = t.top + o + e - s, w = t.top < 0 ? n : t.bottom > window.innerHeight ? o + t.bottom - window.innerHeight + e : o, p = {
        start: n,
        center: t.top + o - window.innerHeight / 2 + t.height / 2 + e,
        end: t.top + o - window.innerHeight + t.height + e,
        nearest: w
      }[l] ?? n, u = d;
      window.scrollTo({
        top: p,
        left: u,
        behavior: i
      });
    },
    []
  );
}
export {
  m as useScrollIntoView
};
